/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomerExternalNumber } from '../models/customer-external-number';
import { findAll6 } from '../fn/customer-external-number/find-all-6';
import { FindAll6$Params } from '../fn/customer-external-number/find-all-6';

@Injectable({ providedIn: 'root' })
export class CustomerExternalNumberService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findAll6()` */
  static readonly FindAll6Path = '/api/values/customer-external-number';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAll6()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll6$Response(params?: FindAll6$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomerExternalNumber>>> {
    return findAll6(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findAll6$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll6(params?: FindAll6$Params, context?: HttpContext): Observable<Array<CustomerExternalNumber>> {
    return this.findAll6$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CustomerExternalNumber>>): Array<CustomerExternalNumber> => r.body)
    );
  }

}
